import { useState } from "react";
import { SousLogo } from "@withsous/common";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-neutral-200">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <SousLogo size={36} className="text-primary-600" />
            <span className="text-2xl font-bold text-neutral-900">WithSous</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className="text-neutral-700 hover:text-primary-600 transition">
              Features
            </a>
            <a href="#how-it-works" className="text-neutral-700 hover:text-primary-600 transition">
              How It Works
            </a>
            <a
              href="https://withsous.app"
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
            >
              Get Started
            </a>
          </div>
          <button
            className="md:hidden p-2 text-neutral-700 hover:text-primary-600"
            onClick={toggleMobileMenu}
            aria-expanded={mobileMenuOpen}
            aria-label="Toggle menu"
          >
            <svg
              className={mobileMenuOpen ? "hidden" : "block w-6 h-6"}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              className={mobileMenuOpen ? "block w-6 h-6" : "hidden"}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div role="menu" className="md:hidden mt-4 py-4 space-y-4 border-t border-neutral-200">
            <a
              href="#features"
              className="block text-neutral-700 hover:text-primary-600 transition py-2"
              onClick={closeMobileMenu}
            >
              Features
            </a>
            <a
              href="#how-it-works"
              className="block text-neutral-700 hover:text-primary-600 transition py-2"
              onClick={closeMobileMenu}
            >
              How It Works
            </a>
            <a
              href="https://withsous.app"
              className="block px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition text-center"
              onClick={closeMobileMenu}
            >
              Get Started
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
